module.exports = __webpack_public_path__ + "img/gradient-8.524a32e9.png";